import supportedLocales from '@/config/supported-locales';

export default {

  getSupportedLocales() {
    const annotatedLocales = [];

    Object.keys(supportedLocales).forEach((key) => {
      annotatedLocales.push({
        code: key,
        name: supportedLocales[key],
      });
    });

    return annotatedLocales;
  },

  supportedLocalesInclude(locale) {
    return Object.keys(supportedLocales).includes(locale);
  },

};
